import {IHttpService} from "angular";
import {SecurityDividendsRecord} from "app/dividends/types/DividendsRecord";

export class DividendsService {

    public static readonly id = "dividendsService";

    /** @ngInject */
    public constructor(private readonly $http: IHttpService) {

    }

    public async latest(): Promise<SecurityDividendsRecord> {
        const url = "/tradefloor/api/dividends";
        const response = await this.$http.get<SecurityDividendsRecord>(url);
        return response.data;
    }
}
